import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';
import './MyListings.css';

const CAT_LABEL = { street_legal:'Street Legal', mini_moto:'Mini Moto', medium_moto:'Medium Moto', mega_moto:'Mega Moto', part:'Part', accessory:'Accessory' };

export default function MyListings() {
  const { user } = useAuth();
  const navigate  = useNavigate();
  const [listings, setListings] = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    if (!user) { navigate('/login'); return; }
    supabase.from('listings').select('*').eq('seller_id', user.id).order('created_at', { ascending: false })
      .then(({ data }) => { setListings(data || []); setLoading(false); });
  }, [user]);

  const toggle = async (id, cur) => {
    await supabase.from('listings').update({ is_active: !cur }).eq('id', id);
    setListings(p => p.map(l => l.id === id ? { ...l, is_active: !cur } : l));
  };

  const del = async (id) => {
    if (!window.confirm('Delete this listing permanently?')) return;
    await supabase.from('listings').delete().eq('id', id);
    setListings(p => p.filter(l => l.id !== id));
  };

  if (loading) return <div className="spinner" />;

  return (
    <div className="my-listings-page page-enter">
      <div className="container">
        <div className="my-listings-header">
          <div>
            <h1>My Listings</h1>
            <p className="sub-count">{listings.length} listing{listings.length !== 1 ? 's' : ''}</p>
          </div>
          <Link to="/sell" className="btn btn-primary">New Listing</Link>
        </div>

        {listings.length === 0 ? (
          <div className="empty-state">
            <h3>No listings yet</h3>
            <p>Start selling your e-moto or parts.</p>
            <Link to="/sell" className="btn btn-primary" style={{ marginTop: 20 }}>Create First Listing</Link>
          </div>
        ) : (
          <div className="ml-table">
            {listings.map(l => (
              <div key={l.id} className={`ml-row ${!l.is_active ? 'paused' : ''}`}>
                <div className="ml-img">
                  {l.images?.[0] ? <img src={l.images[0]} alt={l.title} /> : <span className="ml-no-img">{(CAT_LABEL[l.category]||'?')[0]}</span>}
                </div>
                <div className="ml-info">
                  <Link to={`/listings/${l.id}`} className="ml-title">{l.title}</Link>
                  <p className="ml-meta">
                    <span className="mono">${Number(l.price).toLocaleString()}</span>
                    <span className="badge badge-violet" style={{ fontSize:'0.65rem' }}>{CAT_LABEL[l.category]||l.category}</span>
                    <span>{l.views||0} views</span>
                    <span>{new Date(l.created_at).toLocaleDateString()}</span>
                  </p>
                </div>
                <div className="ml-status">
                  <span className={`dot ${l.is_active ? 'live' : 'paused'}`} />
                  {l.is_active ? 'Live' : 'Paused'}
                </div>
                <div className="ml-actions">
                  <Link to={`/sell/edit/${l.id}`} className="btn btn-ghost btn-sm">Edit</Link>
                  <button className="btn btn-ghost btn-sm" onClick={() => toggle(l.id, l.is_active)}>{l.is_active ? 'Pause' : 'Activate'}</button>
                  <button className="btn btn-ghost btn-sm red-ghost" onClick={() => del(l.id)}>Delete</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
